export function initRecentProductsSlider() {
	document.addEventListener('DOMContentLoaded', function () {
		const recentProductsSliders = document.querySelectorAll('.blockRecentProducts__slider');

		if (recentProductsSliders) {
			recentProductsSliders.forEach(recentProductsSlider => {
				const splide = new window.splide(recentProductsSlider, {
					autoWidth: false,
					pagination: true,
					arrows: true,
					perPage: 5,
					perMove: 1,
					gap: '24px',
					autoplay: true,
					interval: 2000,
					rewind: true,
					breakpoints: {
						1380: {
							arrows: false,
						},
						1224: {
							perPage: 4,
							arrows: false,
						},
						991: {
							perPage: 3,
							arrows: false,
						},
						767: {
							autoWidth: true,
							arrows: false,
						},
					}
				});

				splide.on('overflow', function (isOverflow) {
					if (!isOverflow) {
						splide.go(0);

						splide.options = {
							arrows: isOverflow,
							pagination: isOverflow,
							drag: isOverflow,
							clones: isOverflow ? undefined : 0,
						};
					}
				});

				splide.mount();
			})
		}
	})
}